import type { ResponseError } from '@shared/types/error';

export const isResponseError = (error: unknown): error is ResponseError => {
  if (error === null || error === undefined) {
    return false;
  }
  if (
    typeof error === 'object' &&
    'status' in error &&
    'message' in error &&
    'name' in error
  ) {
    return true;
  } else {
    return false;
  }
};
